import * as React from 'react';

const AmountBedrooms = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={22} height={22} viewBox="0 0 22 22" {...props}>
        <g
            fill="none"
            fillRule="evenodd"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.3}
        >
            <path d="M1.625 7.875 11 1.625l9.375 6.25M2.875 16.625h16.25v3.75H2.875v-8.75" />
            <path d="M5.375 12.875h-2.5v3.75h5v-1.25a2.5 2.5 0 0 0-2.5-2.5M16.625 12.875h-3.932a3.75 3.75 0 0 0-3.355 2.073L8.5 16.625h10.625v-1.25a2.5 2.5 0 0 0-2.5-2.5" />
        </g>
    </svg>
);
export default AmountBedrooms;
